module.exports = __webpack_public_path__ + "img/closecross.6341bf44.png";